import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ReservationsLayer from "../components/ReservationsLayer";

const ReservationsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Reservations" />
      <ReservationsLayer />
    </MasterLayout>
  );
};

export default ReservationsPage;
